import axios from "axios";
import {axiosApi, currentApi} from "../configs/apiConfig";
import {toast} from "react-hot-toast";
import {ICreateCustomerDto} from "../dtos/customers/ICreateCustomerDto";
import {ICustomerDto} from "../dtos/customers/ICustomerDto";
import {AppDependencies} from "./appDependencies";

export class CustomerService {
    async GetAll(searchText?: string) {
        let url = `/customers`;
        if (searchText && searchText !== "") {
            url += `/${searchText}`;
        }

        const response = await AppDependencies.Axios.get(url);
        return response.data;
    }

    async GetByProjects() {
        const url = `/customers/entries/by-projects`;
        const response = await AppDependencies.Axios.get(url);
        return response.data;
    }

    async Create(item: ICreateCustomerDto) {
        try {
            const response = await AppDependencies.Axios.post(`/customers`, item, {});
            if (process.env.MODE === "debug") {
                console.log(response);
            }

            if (response.status === 200) {
                toast.success("Created successfully!");
                return true;
            } else if (response.status === 400) {
                console.log(response.data);
                toast.error("Customer with this TIN already exists!");
                return false;
            } else {
                throw `requestError. status code ${response.status}`;
            }
        } catch (e) {
            if (process.env.MODE === "debug") {
                console.log(e);
            }

            toast.error("Create failure!");
        }
        return false;
    }

    async Update(item: ICustomerDto) {
        try {
            const response = await AppDependencies.Axios.put(`/customers`, item, {});
            if (process.env.MODE === "debug") {
                console.log(response);
            }

            if (response.status === 200) {
                toast.success("Updated successfully!");
                return true;
            } else {
                throw `requestError. status code ${response.status}`;
            }
        } catch (e) {
            if (process.env.MODE === "debug") {
                console.log(e);
            }

            toast.error("Update failure!");
        }
        return false;
    }

    async Delete(id: string) {
        try {
            const response = await AppDependencies.Axios.delete(`/customers/${id}`);
            if (process.env.MODE === "debug") {
                console.log(response);
            }

            if (response.status === 200) {
                toast.success("Deleted successfully!");
                return true;
            } else {
                throw `requestError. status code ${response.status}`;
            }
        } catch (e) {
            if (process.env.MODE === "debug") {
                console.log(e);
            }

            toast.error("Delete failure!");
        }
        return false;
    }

    async GetOne(id: string): Promise<ICustomerDto | null> {
        const url = `/customers/one/${id}`;
        const response = await AppDependencies.Axios.get(url);
        if (response) {
            return response.data;
        }
        return null;
    }
}
